var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { action: "#l", method: "post" } }, [
      _c("div", { staticClass: "title-container" }, [
        _c("h2", { staticClass: "search-title" }, [
          _vm._v(
            _vm._s(_vm.searchboxheadlineflightluggage[_vm.getCurrentLocale])
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale])),
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "soap-icon-baggage-status" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "search-content" }, [
        _c("div", { staticClass: "col-md-12", attrs: { id: "main" } }, [
          _c("h4", { staticClass: "skin-color" }, [
            _vm._v(_vm._s(_vm.luggagetitle[_vm.getCurrentLocale])),
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.luggagetext1[_vm.getCurrentLocale]),
            },
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "contact-address block" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "icon-box style5" }, [
                  _c("i", { staticClass: "soap-icon-baggage-status" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description",
                      staticStyle: { "padding-top": "6px" },
                    },
                    [
                      _c("h5", { staticStyle: { "margin-bottom": "5px" } }, [
                        _vm._v(
                          "\n                                        " +
                            _vm._s(_vm.handluggage[_vm.getCurrentLocale]) +
                            " (1 " +
                            _vm._s(_vm.piece[_vm.getCurrentLocale]) +
                            ")"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                        " +
                            _vm._s(_vm.dimensions[_vm.getCurrentLocale]) +
                            ": max. 55cm x 40cm x 20cm , " +
                            _vm._s(_vm.weight[_vm.getCurrentLocale]) +
                            ": max. 6kg\n                                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button sundair",
                          attrs: {
                            href: "/infos-luggage/#/luggage",
                            title: "",
                            target: "_new",
                          },
                        },
                        [_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-address block" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "icon-box style5" }, [
                  _c("i", { staticClass: "soap-icon-baggage-status" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description",
                      staticStyle: { "padding-top": "6px" },
                    },
                    [
                      _c("h5", { staticStyle: { "margin-bottom": "5px" } }, [
                        _vm._v(
                          "\n                                        " +
                            _vm._s(
                              _vm.abandonableluggage[_vm.getCurrentLocale]
                            ) +
                            " (1 " +
                            _vm._s(_vm.piece[_vm.getCurrentLocale]) +
                            ")"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                        " +
                            _vm._s(_vm.weight[_vm.getCurrentLocale]) +
                            ": max. 20kg\n                                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button sundair",
                          attrs: {
                            href: "/infos-luggage/#/luggage",
                            title: "",
                            target: "_new",
                          },
                        },
                        [_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("h4", {
            domProps: {
              innerHTML: _vm._s(_vm.luggagetext3[_vm.getCurrentLocale]),
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab-pane fade in active image-style style2",
            attrs: { id: "honeymoon1" },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "button btn-medium icon-check uppercase full-width",
                attrs: { href: "/services" },
              },
              [_vm._v(_vm._s(_vm.seatsbutton[_vm.getCurrentLocale]))]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 column-in-center" }, [
        _c("ul", { staticClass: "image-block clearfix" }, [
          _c("li", { staticStyle: { "z-index": "5", left: "50px" } }, [
            _c(
              "a",
              {
                staticClass: "middle-block",
                staticStyle: {
                  width: "80px",
                  height: "80px",
                  position: "relative",
                },
                attrs: { href: "/services" },
              },
              [
                _c("img", {
                  staticClass: "middle-item",
                  staticStyle: {
                    position: "absolute",
                    top: "50%",
                    "margin-top": "-40px",
                    left: "50%",
                    "margin-left": "-66.5px",
                  },
                  attrs: {
                    width: "133",
                    height: "88",
                    alt: "",
                    src: "/res/images/services/seats/tabs_banner_5.png",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "4", left: "180px", top: "100px" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "100px",
                    height: "100px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-50px",
                      left: "50%",
                      "margin-left": "-75px",
                    },
                    attrs: {
                      width: "150",
                      height: "100",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_4.jpg",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "3", left: "250px", top: "20px" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "150px",
                    height: "150px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-75px",
                      left: "50%",
                      "margin-left": "-110px",
                    },
                    attrs: {
                      width: "220",
                      height: "196",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_2.png",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "2", left: "100px", top: "0" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "160px",
                    height: "160px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-80px",
                      left: "50%",
                      "margin-left": "-156px",
                    },
                    attrs: {
                      width: "312",
                      height: "208",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_3.png",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticStyle: { "z-index": "1", left: "0", top: "30px" } },
            [
              _c(
                "a",
                {
                  staticClass: "middle-block",
                  staticStyle: {
                    width: "156px",
                    height: "156px",
                    position: "relative",
                  },
                  attrs: { href: "/services" },
                },
                [
                  _c("img", {
                    staticClass: "middle-item",
                    staticStyle: {
                      position: "absolute",
                      top: "50%",
                      "margin-top": "-78px",
                      left: "50%",
                      "margin-left": "-117.5px",
                    },
                    attrs: {
                      width: "235",
                      height: "156",
                      alt: "",
                      src: "/res/images/services/seats/tabs_banner_1.jpg",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }